import { environment } from "environments/environment";
export const BASE_URL = environment.BASE_URL;
export const SERVICE_URL = environment.BASE_URL;
export const ACCOUNTS_URL = environment.ACCOUNTS_URL;

export const REST_API_REQUEST_CALL_URL = {
  BASE_URL: BASE_URL,
  API_INNER: SERVICE_URL + "inner/",
  SERVICE_URL: SERVICE_URL,
  LOGIN_URL: BASE_URL + "login",
  TOKEN_URL: SERVICE_URL + "auth/sso/token",
  SESSION_DATA_URL: SERVICE_URL + "auth/login-user",
  LOGOUT_URL: SERVICE_URL + "auth/sso/logout",
  GET_CONSULT_LIST_URL: BASE_URL + "admin/consult",
  POST_CONSULT_REQ_URL: BASE_URL + "zimgo/consulting/inner/legacy",
  GET_CONSULT_STUS_CD_CNT_URL: BASE_URL + "admin/consult/cnt",
  GET_CONSULT_REPORT_URL: BASE_URL + "consult/report/",
  GET_CONSULT_COUNTRY_RATE_URL: BASE_URL + "consult/country/rate/",
  POST_CONSULT_QUOT: BASE_URL + "admin/consult/quot",
  // POST_CONSULT_QUOT_CANCEL : BASE_URL + 'admin/consult/quot/cancel/',
  POST_CONSULT_QUOT_CANCEL:
    BASE_URL + "zimgo/consulting/inner/legacy/quot/cancel/",
  GET_QUOT_ROUTE_LIST_URL: BASE_URL + "consult/route/",
  GET_CONSULT_REQ: BASE_URL + "consult/",
  GET_CONSULT_QUOT: BASE_URL + "consult/",
  GET_COST_ITE_URL: BASE_URL + "costitem",
  POST_MESSAGE_ACTION_URL: BASE_URL + "messages/action",
  GET_MESSAGE_ACTION_URL: BASE_URL + "messages/action",
  POST_MESSAGE_URL: BASE_URL + "messages/master",
  GET_MESSAGE_URL: BASE_URL + "messages/master",
  POST_CONSULT_DOC: BASE_URL + "zimgo/consulting/shipper/legacy/document/",
  GET_CONSULT_DOC: BASE_URL + "consult/document/",
  DEL_CONSULT_DOC: BASE_URL + "consult/deldocument",
  POST_CONSULT_REQ_DOC: BASE_URL + "consult/reqdocument",
  POST_CONSULT_REQ_BOOK: BASE_URL + "zimgo/consulting/shipper/legacy/book",
  POST_CONSULT_CANCEL_BOOK:
    BASE_URL + "zimgo/consulting/shipper/legacy/bookncancel",
  POST_CONSULT_UPDATE_STUS_CD: BASE_URL + "admin/consult/stusCd",
  GET_LG_MESSAGES_URL: BASE_URL + "admin/messages/log",
  GET_CONSULT_LG_MESSAGES_URL: BASE_URL + "messages/log/consult/",
  POST_UPDATE_LG_MESSAGES_STATUS_URL: BASE_URL + "messages/log/stusCd",
  GET_COUNTRY_LIST_URL: BASE_URL + "json/cntry.json",
  GET_CITY_LIST_URL: BASE_URL + "json/city/",
  GET_PORT_LIST_URL: BASE_URL + "port",
  GET_AIR_PORT_LIST_URL: BASE_URL + "airport",
  GET_AIR_LINE_LIST_URL: BASE_URL + "airline",
  GET_OCEA_LINE_LIST_URL: BASE_URL + "oceanline",
  GET_CFS_LIST_URL: BASE_URL + "admin/consult/cfs",
  POST_CONSULT_PICKUP: BASE_URL + "consult/pickup",
  POST_CONSULT_BOOKING_APPROVAL: BASE_URL + "admin/consult/book/approval",
  // POST_CONSULT_BOOKING_SHEET: BASE_URL + 'admin/consult/book',
  // POST_CONSULT_SHIPPING_ADVICE: BASE_URL + 'admin/consult/shippingadvice',
  POST_CONSULT_BOOK_TRUCK: BASE_URL + "admin/consult/booktruck", //truckingYn : 1 or 0(배차 전/후) 버튼분리
  POST_CONSULT_SHIP_TRUCK: BASE_URL + "/admin/consult/shpnadvtruck",
  POST_CONSULT_TRUCK: BASE_URL + "admin/consult/truck",
  GET_QUOT_ROUTE: BASE_URL + "consult/route/",
  POST_QUOT_ROUTE: BASE_URL + "consult/route/",
  POST_CONSULT_COMMENT: BASE_URL + "admin/consult/comment",
  POST_CNTR_LIST: BASE_URL + "admin/consult/cntr/",
  POST_BL_NUMBER: BASE_URL + "consult/bl/",
  POST_DELETE_MESSAGE_MASTER: BASE_URL + "messages/master/",
  GET_CONSULT_TRACK: BASE_URL + "consult/track/",
  GET_ADMIN_CFS_LIST_URL: BASE_URL + "admin/cfs",

  GET_CURRENCY: BASE_URL + "currency/",
  GET_CURRENCY_MAP: BASE_URL + "crncyMap",
  GET_USER_LIST: BASE_URL + "user/v2/admin",

  POST_CMPLT_REQ: BASE_URL + "admin/consult/complete/",
  POST_CMPLT_CANCEL_REQ: BASE_URL + "admin/consult/complete/",
};



// WEBPACK FOOTER //
// ./src/app/utils/rest-api-request-url.ts